import React, { useState } from 'react';
import { FormControl, InputLabel } from '@material-ui/core';
import CreatableSelect from 'react-select/creatable';
import Select from 'react-select';
import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from './Colors';

const useStyles = makeStyles(theme => ({
  formControl: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    minWidth: 120,
    display: 'flex',
    flexGrow: 1,
    textAlign: 'left',
  },
}));

const MySelect = props => {
  const [focus, setFocus] = useState(false);
  const { placeholder, value, SelectComponent, isRequired, error } = props;
  const classes = useStyles();

  const customStyles = {
    control: (base, { isFocused }) => ({
      ...base,
      height: 56,
      minHeight: 56,
      paddingLeft: '3px',
      // marginTop: '16px',
      marginTop: '0px',
      // borderColor: error && !isFocused && '#E53934',
      boxShadow: isFocused ? `0 0 0 1px ${COLORS.blue}` : 'none',
      '&:hover': isFocused
        ? { borderColor: COLORS.blue }
        : { borderColor: '#263238' },
    }),
    menu: base => ({
      ...base,
      zIndex: 1000,
    }),
  };

  return (
    <FormControl
      variant="outlined"
      className={classes.formControl}
      // error={error}
    >
      <InputLabel
        // error={error}
        shrink={focus || !!value}
        style={{
          background: 'white',
          padding: '0px',
          marginLeft: '-4px',
          color: focus && COLORS.blue,
        }}
      >
        <span style={{ padding: placeholder ? '0px 4px' : '0' }}>
          {placeholder}
        </span>
        {isRequired && (
          <span style={{ color: 'red', marginRight: '4px' }}>*</span>
        )}
      </InputLabel>
      <SelectComponent
        {...props}
        styles={customStyles}
        placeholder=""
        onFocus={() => setFocus(true)}
        onBlur={() => {
          setFocus(false);
        }}
      />
    </FormControl>
  );
};

const CustomCreatableSelect = props => (
  <MySelect {...props} SelectComponent={CreatableSelect} />
);

const CustomSelect = props => <MySelect {...props} SelectComponent={Select} />;

export { CustomCreatableSelect, CustomSelect };
